import React, { useState } from 'react';

import { useStripe, PaymentElement, useElements } from '@stripe/react-stripe-js';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom'
import { Alert } from '@mui/material';
import { currencyFormatter } from '../helpers';

const CheckoutForm = ({ paymentIntentId, amount }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [showError, setShowError] = useState();

  const handleLoadError = (event) => {
    setShowError(event.error.message);
    console.log(event.error.message)
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);
    setShowError(null)

    try {
      const result = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        redirect: "if_required"
      });

      if (result.error) {
        // Show error to your customer (for example, payment details incomplete)
        console.log(result.error.message);

        setShowError(result.error.message)
        setIsProcessing(false);
        return;

      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }

      const response = await fetch(process.env.REACT_APP_FN_URL + '/checkout', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ paymentIntentId })
      }).then(res => res.json())

      if (response.status === 'success') {
        switch (response.checkoutType) {
          case 'ticket':
            navigate(`/success/${response.purchaseId}`);
            break;
          case 'voucher':
            navigate('/successVoucher');
            break;
        }
      } else {
        setShowError("Oops, something went wrong. Please contact us.");
      }

    } catch (error) {
      // TODO: display error message in UI (e.g declined, etc.)
      console.log(error)
      setShowError(error.message)
      setIsProcessing(false);
    }
  };

  return (
    <>
      {showError && <Alert severity="error">{showError}</Alert>}
      <form onSubmit={handleSubmit}>
        <PaymentElement onLoadError={handleLoadError} />
        <LoadingButton
          type="submit"
          disabled={!!showError || !stripe || !elements}
          loading={isProcessing}
          variant="contained"
          onClick={handleSubmit}
          fullWidth
          sx={{ mt: 4, mr: 1 }}>
          Pay ({currencyFormatter(amount)})
        </LoadingButton>
      </form >
    </>
  );
};

export default CheckoutForm;
